import { Dialog, Popover, Transition } from "@headlessui/react";
import React, { Fragment, useState, useEffect } from "react";

import ButtonClose from "shared/ButtonClose/ButtonClose";

export interface ModalProps {
    children?: React.ReactNode;
    showAfter?: number;
    lookForFlagInLocalStorage?: string;
    closeModal?: boolean;
    dialogTitle?: string;
    closeOnOutsideClick?: boolean;
}

const Modal: React.FC<ModalProps> = ({
    children = <>No Children</>,
    lookForFlagInLocalStorage = "",
    showAfter = 10,
    closeModal = false,
    closeOnOutsideClick = false,
    dialogTitle,

}) => {
    const [isOpenMoreFilterMobile, setisOpenMoreFilterMobile] = useState(false);

    const closeModalMoreFilterMobile = () => {
        // set flag to session storage
        if (lookForFlagInLocalStorage) localStorage.setItem(lookForFlagInLocalStorage, "true");

        setisOpenMoreFilterMobile(false)
    };
    const openModalMoreFilterMobile = () => setisOpenMoreFilterMobile(true);

    useEffect(() => {
        if (lookForFlagInLocalStorage) {
            const flag = localStorage.getItem(lookForFlagInLocalStorage);

            if (flag) {
                return;
            }
        }

        setTimeout(() => {
            openModalMoreFilterMobile();
        }, showAfter * 1000);
    }, []);

    useEffect(() => {
        if (closeModal === true) {
            closeModalMoreFilterMobile();
        }
    }, [closeModal]);

    const renderModal = () => {
        return (
            <div>
                <Transition appear show={isOpenMoreFilterMobile} as={Fragment}>
                    <Dialog
                        as="div"
                        className="fixed inset-0 top-auto z-50 overflow-y-auto"
                        onClose={() => {
                            if (closeOnOutsideClick) closeModalMoreFilterMobile();
                        }}
                    >
                        <div className="min-h-screen text-center flex h-full items-center justify-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40 dark:bg-opacity-60" />
                            </Transition.Child>

                            {/* This element is to trick the browser into centering the modal contents. */}
                            <span
                                className="flex lg:inline-block h-fit lg:h-screen align-middle"
                                aria-hidden="true"
                            >
                                &#8203;
                            </span>
                            <Transition.Child
                                className="inline-block py-8 px-2 w-full max-w-3xl"
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <div className="inline-flex flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-zinc-900 dark:border dark:border-zinc-700 dark:text-neutral-100 shadow-xl">
                                    <div className="relative flex-shrink-0 px-6 py-4 text-center">
                                        {dialogTitle && (
                                            <Dialog.Title
                                                as="h3"
                                                className="text-lg font-medium leading-6 text-gray-900 dark:text-white"
                                            >
                                                {dialogTitle}
                                            </Dialog.Title>
                                        )}
                                        <span className="absolute left-3 top-3">
                                            <ButtonClose onClick={closeModalMoreFilterMobile} />
                                        </span>
                                    </div>
                                    <div className="w-full max-w-xl mx-auto py-4 pb-8 lg:mt-2">
                                        {children}
                                    </div>
                                </div>
                            </Transition.Child>
                        </div>
                    </Dialog>
                </Transition>
            </div>
        );
    };

    return (
        <React.Fragment>
            <Popover className="relative">
                {({ open }) => {
                    // if (open) {
                    //     setTimeout(() => {
                    //         inputRef.current?.focus();
                    //     }, 100);
                    // }

                    return renderModal()
                }}
            </Popover>
        </React.Fragment>
    );
};

export default Modal;
